import types from './types';

const canUseDom = KYT.EXECUTION_ENVIRONMENT === 'client';

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
export default function auth(
  state = {
    isFetching: false,
    isAuthenticated: canUseDom && localStorage && !!localStorage.getItem('id_token'),
  },
  action
) {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: '',
        ...action.payload,
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.payload.message,
      };
    case types.LOGOUT_REQUEST:
      return {
        ...state,
        isAuthenticated: false,
        access_token: null,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/state/ducks/auth/reducers.js